<app-header></app-header>
<main class="main-content">
    <!------main-content------>
    <!-----------page_title--------------->
    <section class="page_title  pdt_80  pdb_40 min-height-auto" style="padding-bottom: 0px;">
      <div class="container">
         <div class="row">
            <!---------row----------->
            
            <!----------row-end---------->
         </div>
      </div>
   </section>
    <!-----------page_title-end--------------> 
    <!-----------footer--------------->
    <section class="contact_page pdb_70 pdt_50">
       <div class="container">
          <div class="row">

            <div class="col-lg-6">
               <img src="assets/image/login.png" class="img-fluid">
            </div>
             <!---------row----------->
             <div class="col-lg-6 col-md-12 mx-auto">
                <!---------col----------->
                <div class="contact_us_form">
                  <div class="heading tp_one">
                     
                     <h1> Reset Password</h1>
                     
                  </div>
                    
                    <div class="form_box type_one remove-pt">
                      <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmitResetPassword(resetPasswordForm.value)" autocomplete="off">
                         <div class="messages"></div>
                         <div class="controls">
                            <div class="row">

                              <div class="col-lg-12">
                                 <div class="form-group">
                                    <input type="text" class="percent_100 login_input_padding" name="emailAddress" formControlName="emailAddress" placeholder="Enter Email Address"  required="required"
                                    [style.border-color]="submitted &amp;&amp; resetPasswordForm.controls.emailAddress.errors ?'#dc3545' : ''" />
                                    <div *ngIf="submitted &amp;&amp; resetPasswordForm.controls.emailAddress.errors" class="form-text text-danger">
                                          <div *ngIf="resetPasswordForm.controls.emailAddress.errors.required">Email Address is required</div>
                                    </div>
                                 </div>
                              </div>



                               <div class="col-lg-12">
                                  <div class="form-group">
                                     <input [type]="fieldTextType1 ? 'text' : 'password'" class="percent_100 login_input_padding" name="oldPassword" formControlName="oldPassword" placeholder="Default Password"  required="required"
                                     [style.border-color]="submitted &amp;&amp; resetPasswordForm.controls.oldPassword.errors ?'#dc3545' : ''" />
                                    
                                     <div class="input-group-append eye-password">
                                       <div class="input-group-text eye-position">
                                         <span class="fa" [ngClass]="{
                                           'fa-eye': !fieldTextType1,
                                           'fa-eye-slash': fieldTextType1
                                         }"
                                         (click)="toggleFieldTextType1()">
                                       </span>
                                       </div>
                                     </div>

                                    <div *ngIf="submitted &amp;&amp; resetPasswordForm.controls.oldPassword.errors" class="form-text text-danger">
                                       <div *ngIf="resetPasswordForm.controls.oldPassword.errors.required">Default Password is required</div>
                                       <div *ngIf="resetPasswordForm.controls.oldPassword.errors.minlength">Default Password must be 6 character long.</div>
                                       
                                    </div>
                                  </div>
                               </div>
                               <div class="col-lg-12">
                                <div class="form-group">
                                   <input [type]="fieldTextType2 ? 'text' : 'password'" class="percent_100 login_input_padding ng-pristine ng-invalid ng-touched" name="newPassword" formControlName="newPassword" placeholder="New Password"  required="required"
                                   [style.border-color]="submitted &amp;&amp; resetPasswordForm.controls.newPassword.errors ?'#dc3545' : ''" />
                                  
                                   <div class="input-group-append eye-password">
                                    <div class="input-group-text eye-position">
                                      <span class="fa" [ngClass]="{
                                        'fa-eye': !fieldTextType2,
                                        'fa-eye-slash': fieldTextType2
                                      }"
                                      (click)="toggleFieldTextType2()">
                                    </span>
                                    </div>
                                  </div>

                                 <div *ngIf="submitted &amp;&amp; resetPasswordForm.controls.newPassword.errors" class="form-text text-danger">
                                    <div *ngIf="resetPasswordForm.controls.newPassword.errors.required">New Password is required</div>
                                    <div *ngIf="resetPasswordForm.controls.newPassword.errors.minlength">New Password must be 8 character long.</div>
                                    <div *ngIf="resetPasswordForm.controls.newPassword.errors.pattern">New Password must be combination of below:<br>1 Upper Case [A-Z] <br> 1 Lower Case [a-z] <br>1 Digit [0-9] <br>1 Special Character ?=.*?[#?!@$%^&*-]</div>
                                 </div>

                                </div>
                             </div>
                             <div class="col-lg-12">
                                <div class="form-group">
                                   <input [type]="fieldTextType3 ? 'text' : 'password'" class="percent_100 login_input_padding ng-pristine ng-invalid ng-touched" name="confirmPassword" formControlName="confirmPassword" placeholder="Confirm Password"  required="required"
                                   [style.border-color]="submitted &amp;&amp; resetPasswordForm.controls.confirmPassword.errors ?'#dc3545' : ''" />
                                   
                                   <div class="input-group-append eye-password">
                                    <div class="input-group-text eye-position">
                                      <span class="fa" [ngClass]="{
                                        'fa-eye': !fieldTextType3,
                                        'fa-eye-slash': fieldTextType3
                                      }"
                                      (click)="toggleFieldTextType3()">
                                    </span>
                                    </div>
                                  </div>

                                 <div *ngIf="submitted &amp;&amp; resetPasswordForm.controls.confirmPassword.errors" class="form-text text-danger">
                                    <div *ngIf="resetPasswordForm.controls.confirmPassword.errors.required">Confirm Password is required</div>
                                    <div *ngIf="resetPasswordForm.controls.confirmPassword.errors.minlength">Confirm Password must be 8 character long.</div>
                                    <div *ngIf="resetPasswordForm.controls.confirmPassword.errors.pattern">Confirm Password must be combination of below:<br>1 Upper Case [A-Z] <br> 1 Lower Case [a-z] <br>1 Digit [0-9] <br>1 Special Character ?=.*?[#?!@$%^&*-]</div>
                                 </div>
                                </div>
                             </div>
                              
                               
                             <div class="col-lg-12 text-center">
                                 <div class="form-group ">
                                    <button class="theme_btn tp_two" type="submit" >Submit</button><br><br>
                                    <a href="#"class="link-back-to-login">Back to Login</a>
                                 </div>
                              </div>
                              
                              
                            </div>
                         </div>
                      </form>
                   </div>
                </div>
                <!---------col-end---------->
             </div>
             
          </div>
       </div>
    </section>
<app-footer></app-footer>
    
</main>
<app-scrolltotop></app-scrolltotop>

